export const stunConfigCredentials = {
    host: 'conference-turn.wildix.com',
    port: '443',
    urls: 'turn:conference-turn.wildix.com:443',
    username: '-',
    password: '-'
};
